export const COMMON_STYLES = {
  text: 'text-fuel-dark text-sm font-normal',
  textMuted: 'text-fuel-dark/70 text-sm font-normal',
  flexColumn: 'w-full flex flex-col justify-start items-start gap-2',
  flexRow: 'flex justify-start items-start gap-4',
  clickable: 'cursor-pointer hover:opacity-80',
  textPrimary: 'text-fuel-primary text-sm font-medium',
  textTitle: 'text-black-title text-sm font-medium'
};
